var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminShell',{attrs:{"page-title":_vm.pageTitle,"page-subtitle":_vm.pageSubtitle,"active-menu":"customer-service"}},[_c('div',{staticClass:"customer-contact-page"},[_c('div',{staticClass:"page-shell"},[_c('CustomerContactManager',{attrs:{"embedded":false,"show-back-button":false}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }